import { graphql } from "react-relay";
import { FeedScheduler } from "@components/feed-scheduler";
import { AvatarPerson } from "@components/avatar";

export const fragments = {
  org: graphql`
    fragment ChromeDayPicker_org on Org {
      ...AvatarPerson_org
      id
      primaryOrgEmail
      personForUserErrorable {
        __typename
        ... on Person {
          ...AvatarPerson_person
          id
          primaryEmail
          emails
          profile {
            givenName
            familyName
            externalImageUrl
          }
        }
      }
    }
  `,
};
